<template>
    <v-dialog max-width="400" persistent :value="value" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Inserisci Password
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="checkPwd()">
                      <v-icon color="success">mdi-check</v-icon>
                  </v-btn>
                  </template>
                  <span>Procedi</span>
              </v-tooltip>   
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.native="closePWD()">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-2">
                <v-col md="12" cols="12">
                    <v-text-field
                        label="Password"
                        outlined
                        autofocus
                        autocomplete="off"
                        color="info"
                        prepend-inner-icon="mdi-lock"
                        v-model="settingsPassword"
                        ref="settingsPassword"
                        name="settingsPassword"
                        counter="40"
                        hint="Password per accesso area Impostazioni"
                    >
                    </v-text-field>  
                </v-col>
            </v-row>
        </v-card> 
    </v-dialog>   
</template>
<script>
export default {
    props:['value'],
    data () {
    return {
      dialog:false,
      settingsPassword:null
    }},
    methods:
    {
        checkPwd()
        {
          console.log(415,this.settingsPassword)
          this.loading_update=true;
          this.$emit('checkPwd',this.settingsPassword);
          this.$emit('input', false)
        },
        closePWD()
        {
            this.$router.push('/manage').catch(() => {});
        }
    }
}
</script>